
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorOffHorizontal as ObiMotorOffHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-off-horizontal.js';
 
 
 

 
 export const ObiMotorOffHorizontal = createComponent({
   react: React,
   tagName: 'obi-motor-off-horizontal',
   elementClass: ObiMotorOffHorizontalElement,
   events: {
     
   }
  });
 
 